import {
  CustomValueOption,
  CustomValueSelectProps
} from "PFApp/components/custom_value_select/custom_value_select";
import { CustomType, Id, PureCustomValueData } from "PFTypes";
import { RefObject } from "react";

import { CustomValuesEditFieldProps } from "../custom_values_edit_field.types";

export type SelectFieldConfig = Pick<
  CustomValuesEditFieldProps,
  | "displayValuesBelow"
  | "onRestore"
  | "letClear"
  | "createOptionBlocklist"
  | "restoreLabel"
  | "renderDisplayValues"
  | "disabled"
  | "parseOptions"
  | "portalRef"
  | "dropdownWidth"
  | "focusSearchInputOnOpen"
  | "inputRef"
> & {
  customType: CustomType | null;
  connectedValuesIds: Id[];
  hasExpiryDate?: boolean;
  finalLetCreate: boolean | null;
  fetchOptions: NonNullable<CustomValueSelectProps["fetchOptions"]>;
  handleExpiryDateChange: (option: CustomValueOption) => void;
  handleCreate: (createdOption: CustomValueOption) => Promise<CustomValueOption>;
  variant: "default" | "table";
};

type BuildCommonSelectPropsParams = SelectFieldConfig & {
  dropdownIdPrefix: string;
  values: PureCustomValueData[];
  locked: boolean;
  handleChange: (values: PureCustomValueData[]) => void;
  createDescriptionTip?: string;
};

export const buildCommonSelectProps = ({
  dropdownIdPrefix,
  customType,
  connectedValuesIds,
  values,
  locked,
  hasExpiryDate,
  finalLetCreate,
  fetchOptions,
  handleChange,
  handleExpiryDateChange,
  handleCreate,
  displayValuesBelow,
  onRestore,
  letClear,
  createOptionBlocklist,
  restoreLabel,
  renderDisplayValues,
  disabled,
  parseOptions,
  portalRef,
  variant,
  dropdownWidth,
  focusSearchInputOnOpen,
  inputRef,
  createDescriptionTip
}: BuildCommonSelectPropsParams) => ({
  dropdownId: `${dropdownIdPrefix}-${customType?.name}-${connectedValuesIds}`,
  fetchOptions,
  displayValueBelow: displayValuesBelow,
  withExpiryDate: hasExpiryDate,
  onRestore,
  onDateChange: handleExpiryDateChange,
  onClear: letClear && values.length > 0 ? () => handleChange([]) : undefined,
  onCreateOption: finalLetCreate ? handleCreate : undefined,
  createOptionBlocklist,
  restoreLabel,
  displayValues: renderDisplayValues?.(locked || disabled),
  isFetchingSelectedOptions: false,
  parseOptions,
  tooltipAppendTo: (portalRef as RefObject<HTMLElement | null> | undefined)?.current || undefined,
  createButton: {
    ...(customType?.name === "skills" && createDescriptionTip && { tooltipContent: createDescriptionTip })
  },
  portalRef,
  variant,
  dropdownWidth,
  focusSearchInputOnOpen,
  inputRef
});
